<template>
  <div class="introVideosWrapper introVideosModal">
      <new-modal-wrapper
        widthModal="100%"
        modal-name="introVideos"
        :fullHeight="true"
        :heightModal="fullScreen || isMobile? '100%' : 'auto'"
        content-component="introVideos"
        cta-primary-button="ugcIntroVideosModalButton"
        :max-width-modal="fullScreen ? Infinity : 500"
        @cta-action="onNext()"
        @before-close="onCloseModal()"
        :headerTitle="title"
        :showCloseIcon="type === 'customizer'"
      >
        <intro-videos v-if="steps || steps.length > 0" :onSlideChange="onSlideChange" :onNext="onNext" :steps="steps" :assetsPath="assets"></intro-videos>
      </new-modal-wrapper>
  </div>
</template>


<script>

import IntroVideos from '@/components/IntroVideos';
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';

import introVideos from '@/mixins/UGC/introVideos';

export default {
  name: 'IntroVideosWrapper',
  mixins: [introVideos],
  components: {
    IntroVideos,
    newModalWrapper
  },
  props: {
    type: {
      type: String,
      default: 'customizer',
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    autoOpen: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
